<template>
    <q-submenu :title="title" :titlelink="titlelink" :buttons="buttons" :submenu="submenu"></q-submenu>
</template>

<script>
import QSubmenu from '@/components/navigation/Submenus/QSubmenu.vue'
export default {
    components: {
        QSubmenu
    },
    data() {
        return {
            title: "Messages",
            titlelink: [{
                label: "",
                link: "",
            }],
            submenu: [{
                label: "Help",
                to: "/support"
            }]
        }
    },

    computed: {
        buttons() {
            return [
                {
                    label: "Messages Inbox",
                    to: { name: 'Notices' },
                    icon: "fas fa-arrow-alt-circle-down",
                },
                this.hasRole(['SuperAdmin', 'AgencyOwner', "Exec", 'Staff']) && this.notRole(['SalesRep', 'UnlicensedAgent']) && {
                    label: "Sent Messages",
				  					to: { name: 'PopupNoticeAdmin' },
                    icon: "fas fa-arrow-alt-circle-down",
                },
            ].filter(Boolean)
        }
    }
}
</script>

